export default __webpack_public_path__ + "352820e0692ee8bf37232ae016c1d323.png";